/* Namespace: op-kai-*  |  Traduce "select"→"izberite", "close"→"zapreti"
   y aplica padding al título con comportamiento responsive (móvil/desktop). */

(function () {
  // —— Utils ——
  function textEquals(t, word) {
    return (t || '').trim().toLowerCase() === word;
  }

  // Responsive padding: 28px móvil (≤749px), 20px desktop
  const mq = window.matchMedia('(max-width: 749px)');
  function applyResponsiveTitlePadding(el) {
    if (!el) return;
    const isMobile = mq.matches;
    el.style.paddingTop = isMobile ? '28px' : '20px'; // en px
    el.classList?.add('op-kai-title');
  }
  // Reaplicar al cambiar ancho
  mq.addEventListener?.('change', () => {
    document.querySelectorAll('.op-kai-title').forEach(applyResponsiveTitlePadding);
  });

  function findTitle(modalRoot) {
    let t =
      modalRoot.querySelector('[role="heading"]') ||
      modalRoot.querySelector('h1, h2, h3') ||
      modalRoot.querySelector('.modal-title, .popup-title, [class*="title"]');
    if (!t) {
      const hdr =
        modalRoot.querySelector('.modal-header, [class*="header"]') || modalRoot;
      t = hdr.querySelector('h1, h2, h3, [class*="title"]');
    }
    return t || null;
  }

  function replaceVisibleText(root, fromWord, toWord) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue) return NodeFilter.FILTER_REJECT;
        const val = node.nodeValue.trim().toLowerCase();
        return val === fromWord ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    let changed = false, n;
    while ((n = walker.nextNode())) { n.nodeValue = toWord; changed = true; }
    return changed;
  }

  function translateButtons(modalRoot) {
    const allClickables = modalRoot.querySelectorAll('button, [role="button"], a');

    allClickables.forEach((el) => {
      const label = (el.textContent || '').trim();
      const low = label.toLowerCase();
      const aria = (el.getAttribute('aria-label') || '').toLowerCase();
      const data = (el.getAttribute('data-action') || '').toLowerCase();

      // SELECT → izberite
      if (textEquals(low, 'select') || textEquals(data, 'select')) {
        if (label !== 'izberite') el.textContent = 'izberite';
        el.classList.add('op-kai-button');
      }

      // CLOSE → zapreti
      if (textEquals(low, 'close') || aria === 'close' || data === 'close' || /(^|\s)close(\s|$)/.test(low)) {
        const changedDeep = replaceVisibleText(el, 'close', 'zapreti');
        if (!changedDeep && label && low.includes('close')) {
          el.textContent = label.replace(/close/gi, 'zapreti');
        }
        if (aria === 'close') el.setAttribute('aria-label', 'zapreti');
        el.setAttribute('title', 'zapreti');
        el.classList.add('op-kai-secondary');
      }
    });

    // Por si quedan textos sueltos
    replaceVisibleText(modalRoot, 'close', 'zapreti');
    replaceVisibleText(modalRoot, 'select', 'izberite');
  }

  function paintPrimaryButtons(modalRoot) {
    modalRoot.querySelectorAll('.op-kai-button').forEach((btn) => {
      btn.style.backgroundColor = '#02A9E0';
      btn.style.borderColor = '#02A9E0';
      btn.style.color = '#ffffff';
    });
  }

  function translateAndStyle(modalRoot) {
    if (!modalRoot || modalRoot.__opKaiDone) return;

    // Título con padding responsive
    const titleEl = findTitle(modalRoot);
    applyResponsiveTitlePadding(titleEl);

    // Traducciones + estilos
    translateButtons(modalRoot);
    paintPrimaryButtons(modalRoot);

    modalRoot.__opKaiDone = true;

    // Reintentos cortos por inyecciones tardías
    let tries = 0;
    const retry = setInterval(() => {
      tries += 1;
      applyResponsiveTitlePadding(titleEl);
      translateButtons(modalRoot);
      paintPrimaryButtons(modalRoot);
      if (tries >= 6) clearInterval(retry);
    }, 500);
  }

  function looksLikeKaiPopup(node) {
    if (!(node instanceof HTMLElement)) return false;
    const cls = (node.className || '').toString().toLowerCase();
    const role = (node.getAttribute('role') || '').toLowerCase();
    const id = (node.id || '').toLowerCase();

    const modalish =
      role === 'dialog' ||
      cls.includes('modal') || cls.includes('popup') ||
      id.includes('modal') || id.includes('popup') ||
      cls.includes('gift') || cls.includes('freegift') || cls.includes('progress');

    if (!modalish) return false;

    const hasClickables = !!node.querySelector('button, [role="button"], a');
    if (!hasClickables) return false;

    const text = (node.innerText || '').toLowerCase();
    return text.includes('select') || text.includes('close');
  }

  function initialScan() {
    const candidates = document.querySelectorAll(
      '[role="dialog"], .modal, .popup, [class*="gift"], [class*="freegift"], [id*="modal"], [id*="popup"]'
    );
    candidates.forEach((c) => { if (looksLikeKaiPopup(c)) translateAndStyle(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialScan);
  } else {
    initialScan();
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (looksLikeKaiPopup(node)) {
          translateAndStyle(node);
        } else {
          const inner = node.querySelector?.(
            '[role="dialog"], .modal, .popup, [class*="gift"], [class*="freegift"], [id*="modal"], [id*="popup"]'
          );
          if (inner && looksLikeKaiPopup(inner)) translateAndStyle(inner);
        }
      });
      if (m.type === 'childList' || m.type === 'characterData') {
        const root = m.target;
        if (root instanceof HTMLElement && looksLikeKaiPopup(root)) translateAndStyle(root);
      }
    }
  });

  observer.observe(document.documentElement || document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
